import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { IconField } from 'primeng/iconfield';
import { IftaLabelModule } from 'primeng/iftalabel';
import { InputIcon } from 'primeng/inputicon';
import { InputTextModule } from 'primeng/inputtext';
import BodyTypeWriteDTO from '../../../../../../types/body-type/BodyTypeWriteDTO';
import Media from '../../../../../../types/media/Media';
import { BodyTypeService } from '../../../../services/body-type.service';
import {
    SelectOrUploadMediaComponent
} from '../../media/select-or-upload-media-dialog/select-or-upload-media.component';

@Component({
    selector: 'app-create-body-type-dialog',
    templateUrl: './create-body-type-dialog.component.html',
    styleUrls: [ './create-body-type-dialog.component.scss' ],
    imports: [
        DialogModule,
        InputTextModule,
        ButtonModule,
        FormsModule,
        IconField,
        InputIcon,
        IftaLabelModule,
        SelectOrUploadMediaComponent,
    ]
})
export class CreateBodyTypeDialogComponent {
    @Input() visible: boolean = false;
    @Output() visibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output() bodyTypeCreated: EventEmitter<BodyTypeWriteDTO> = new EventEmitter<BodyTypeWriteDTO>();
    public media: Media | undefined = undefined;

    constructor(private bodyTypeService: BodyTypeService,
                private messageService: MessageService) {
    }

    public bodyType: BodyTypeWriteDTO = new BodyTypeWriteDTO({});

    public loading = false;

    get saveDisabled(): boolean {
        return !this.bodyType.name || !this.bodyType.label;
    }

    public close() {
        this.visible = false;
        this.visibleChange.emit(this.visible);
    }

    public saveBodyType() {
        this.loading = true;
        if (this.media) {
            this.bodyType.iconId = this.media.id;
        }
        this.bodyTypeService.createBodyType(this.bodyType).then(() => {
            this.bodyTypeCreated.emit(this.bodyType);
            this.close();
        }).catch((error) => {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: error.message, life: 3000 });
        }).finally(() => {
            this.bodyType = new BodyTypeWriteDTO({});
            this.loading = false;
        });
    }
}
